import * as React from "react";
import { ITableLabelProps, TableLabel } from "./TableLabel";

export const TableLabelName = ({ style, ...props }: ITableLabelProps) => (
    <TableLabel {...props} style={{ textAlign: "left", ...style }} />
);
